// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-wrapper {
  min-height: 120px;
  display: flex;
  padding-left: 8;
  padding-right: 8;
}
.main-wrapper.deletable {
  padding-left: 0;
}
.main-wrapper ion-row,
.main-wrapper ion-col {
  padding: 0;
  width: 100%;
}

.left-col {
  padding-right: 8px;
}
.left-col ion-icon {
  width: 18px;
  height: 24px;
  color: var(--ion-color-medium);
}

#GmbMessage {
  margin-top: 10px;
}

.center-col .source-wrapper {
  display: flex;
  align-items: center;
}
.center-col .source-wrapper .source-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--boxx-app-lightgray, #dedede);
  border-radius: 8px;
  min-width: 36px;
  min-height: 36px;
  margin-right: 16px;
}
.center-col .source-wrapper .source-icon ion-icon.source-email {
  color: var(--ion-color-primary);
  width: 16px;
  height: 16px;
}
.center-col .source-wrapper .source-icon ion-icon.source-email.open {
  color: var(--ion-color-secondary);
}
.center-col .source-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-dark);
}
.center-col .sender-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--ion-text-color);
  margin-top: 8px;
  margin-bottom: 8px;
}
.center-col .sender-email,
.center-col .message-brief {
  color: var(--info-text, #586677);
  font-family: "Montserrat";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  height: 100%;
}
.right-col .conversation-date {
  font-size: 12px;
  font-weight: 500;
  color: #9D9D9C;
  padding-right: 10px;
}
.right-col ion-item {
  --padding-start: 0;
  --padding-end: 0;
  --background: transparent;
}
.right-col ion-item ion-icon[slot=end] {
  margin-left: 24px;
}
.right-col ion-item ion-icon[slot=end]:last-child {
  margin-right: 0px;
}

.center-col .review-rating-wrapper,
.right-col .review-rating-wrapper {
  margin-bottom: -2px;
}
.center-col .review-rating-wrapper .review-stars-icon,
.right-col .review-rating-wrapper .review-stars-icon {
  color: var(--ion-color-medium);
  width: 16px;
  height: 16px;
}
.center-col .review-rating-wrapper .review-stars-icon.active,
.right-col .review-rating-wrapper .review-stars-icon.active {
  color: #f0c300;
}

.action-icon {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/messages-core/lib/components/conversation-item/conversation-item.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;;EAEE,UAAA;EACA,WAAA;AAEJ;;AAEA;EACE,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AAEJ;;AAEA;EACE,gBAAA;AACF;;AAGE;EACE,aAAA;EACA,mBAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACN;AAAM;EACE,+BAAA;EACA,WAAA;EACA,YAAA;AAER;AAAQ;EACE,iCAAA;AAEV;AAGE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AADJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;AADJ;AAGE;;EAEE,gCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AANF;AAQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AAQI;EACE,iBAAA;AANN;AAQI;EACE,iBAAA;AANN;;AAaE;;EACE,mBAAA;AATJ;AAUI;;EACE,8BAAA;EACA,WAAA;EACA,YAAA;AAPN;AASM;;EACE,cAAA;AANR;;AAYA;EACE,eAAA;AATF","sourcesContent":[".main-wrapper {\n  min-height: 120px;\n  display: flex;\n  padding-left: 8;\n  padding-right: 8;\n  &.deletable {\n    padding-left: 0;\n  }\n  ion-row,\n  ion-col {\n    padding: 0;\n    width: 100%;\n  }\n}\n\n.left-col {\n  padding-right: 8px;\n  ion-icon {\n    width: 18px;\n    height: 24px;\n    color: var(--ion-color-medium);\n  }\n}\n\n#GmbMessage{\n  margin-top: 10px;\n}\n\n.center-col {\n  .source-wrapper {\n    display: flex;\n    align-items: center;\n    .source-icon {\n      width: 24px;\n      height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--boxx-app-lightgray, #dedede);\n      border-radius: 8px;\n      min-width: 36px;\n      min-height: 36px;\n      margin-right: 16px;\n      ion-icon.source-email {\n        color: var(--ion-color-primary);\n        width: 16px;\n        height: 16px;\n    \n        &.open {\n          color: var(--ion-color-secondary);\n        }\n      }\n    }\n  }\n  .source-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--ion-color-dark);\n  }\n  .sender-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--ion-text-color);\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n  .sender-email,\n  .message-brief {\n    color: var(--info-text, #586677);\n    font-family: \"Montserrat\";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px; \n    // font-size: 14px;\n    // font-weight: 600;\n    // color: var(--ion-text-color);\n    // margin-bottom: 4px;\n  }\n}\n\n.right-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  height: 100%;\n\n  .conversation-date {\n    font-size: 12px;\n    font-weight: 500;\n    color: #9D9D9C;\n    padding-right: 10px;\n  }\n\n  ion-item {\n    --padding-start: 0;\n    --padding-end: 0;\n    --background: transparent;\n    ion-icon[slot=\"end\"] {\n      margin-left: 24px;\n    }\n    ion-icon[slot=\"end\"]:last-child {\n      margin-right: 0px;\n    }\n  }\n}\n\n.center-col,\n.right-col {\n  .review-rating-wrapper {\n    margin-bottom: -2px;\n    .review-stars-icon {\n      color: var(--ion-color-medium);\n      width: 16px;\n      height: 16px;\n\n      &.active {\n        color: #f0c300;\n      }\n    }\n  }\n}\n\n.action-icon{\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
